
import { i18nText } from '@/locales';

import {Component, Prop, Watch} from "vue-property-decorator";
import {FinanceOperationForm, FormRules} from "@/UI/pages/finance/lib/FinanceOperationForm";
import {mixins} from "vue-class-component";
import {ProxyTableData} from "@/UI/components/Helpers/ProxyTableData";
import {getStudioId} from "@/UI/lib/state";
import {ClientsStore} from "@/store/modules/Clients";
import {PaymentArticlesStore} from "@/store/modules/PaymentArticles";
import {CashboxStore} from "@/store/modules/Finance/Cashbox";
import {CounterpartiesStore} from "@/store/modules/Counterparties";
import {WorkersStore} from "@/store/modules/Workers";
import moment from 'moment';
import {ModalHideOnScrollMix} from "@/UI/mixins/Calendar/ModalHideOnScrollMix";

@Component({
  components: {},
  methods: {moment}
})

export default class FinanceOperationComponent extends mixins(ModalHideOnScrollMix, ProxyTableData) {
  @Prop({default: false}) saving!: boolean;
  @Prop() form!: FinanceOperationForm

  disabled_button: boolean = true
  spin_load: boolean = false
  rules = FormRules
  searchTimeOut: number = 0;
  fetching: boolean = false;
  modal: boolean = true;

  handleRecipientChange(value: any): void {
    this.form.recipient = value;
  }

  changeTime(value: any): void {
    if (!value) this.form.time = ''
    else this.form.time = value.format("HH:mm")
  }

  @Watch('form', {deep: true})
  async watchForm(): Promise<void> {
    this.disabled_button =
        this.form.date &&
        this.form.time &&
        this.form.payment_article &&
        this.form.recipient &&
        this.form.sum ?
            false : true
  }

  onPaymentArticlesSearch(value: string): void {
    clearTimeout(this.searchTimeOut);
    this.fetching = true;
    this.searchTimeOut = setTimeout(async () => {
      await PaymentArticlesStore.fetchAll({filter: {salon_id: getStudioId(this), name: value}})
      this.fetching = false;
    }, 600);
  }

  async onCashboxesSearch(value: string): Promise<void> {
    clearTimeout(this.searchTimeOut);
    this.fetching = true;
    this.searchTimeOut = setTimeout(async () => {
      await this.$store.dispatch('cashbox' + "/fetchAll", {filter: {salon_id: getStudioId(this), name: value}})
      this.fetching = false;
    }, 600);
  }

  async getRecipientData(value?: string): Promise<void> {
    if (!value) value = ''

    if (this.form.recipient_type === 1) {
      await CounterpartiesStore.fetchAll({filter: {salon_id: getStudioId(this), name: value}})
      this.form.recipient_data = this.counterparties
      this.handleRecipientChange(this.form.recipient)
    }
    if (this.form.recipient_type === 2) {
      await ClientsStore.fetchAll({filter: {salon_id: getStudioId(this), name: value}})
      this.form.recipient_data = this.clients
      this.handleRecipientChange(this.form.recipient)
    }
    if (this.form.recipient_type === 3) {
      await WorkersStore.fetchAll({filter: {salon_id: getStudioId(this), name: value}})
      if(!this.workers) return
      this.form.recipient_data = this.workers.filter(worker => worker.status?.id !== 2)
      this.handleRecipientChange(this.form.recipient)
    }
  }

  async changeRadio(): Promise<void> {
    this.spin_load = true
    this.form.recipient = ''

    switch (this.form.recipient_type) {
      case 1:
        this.form.recipient_name = i18nText("Контрагент")
        break;
      case 2:
        this.form.recipient_name = i18nText("Клиент")
        break;
      case 3:
        this.form.recipient_name = i18nText("Сотрудник")
        break;
      default:
        break;
    }

    await this.getRecipientData()
    this.spin_load = false
  }

  get clients() {
    return ClientsStore.clients?.data
  }

  get paymentArticles() {
    return PaymentArticlesStore.paymentArticles?.data
  }

  get cashbox() {
    return CashboxStore.items?.data
  }

  get counterparties() {
    return CounterpartiesStore.counterparties?.data
  }

  get workers() {
    return WorkersStore.workers?.data
  }

  async mounted(): Promise<void> {
    const value = '';
    await PaymentArticlesStore.fetchAll({filter: {salon_id: getStudioId(this), name: value}});
    await CashboxStore.fetchAll({filter: {salon_id: getStudioId(this), name: value}})
    this.paymentArticles;
    this.getRecipientData();
  }
  
}
